import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import moment from 'moment';
import { beginFacebookDiagnostic, reportDiagnostic, diagnosticReason } from '@/services/diagnostics';
import currencies from '@/assets/currencies.json'
import { isManualRecalculationJobRunning } from '@/utils/manualRecalculationJob'

export default {
  namespaced: true,
  state: {
    paymentProviders: [],
    whop: false,
    whopHasHistory: false,
    whopShopName: null,
    marketingCosts: {},
    productCosts: {},
    secondaryProductCosts: {},
    filters: [],
    notifications: [],
    fixPayments: [],
    transactions: [],
    secondaryCountries: [],
    mainCountry: "",
    lastLogin: null,
    currentDateRange: {},
    currentMultiDateRange: {},
    incompleteData: false,
    recPaymentfees: false,
    currentlyLoading: false,
    recalculationJobRunning: false,
    subscriptionLevel: 0,
    freeTrial: true,
    marketingWarning: false,
    reloadData: false,
    recalculationNeeded: false,
    storeCurrency: "",
    incomeTax: 0,
    defaultMargin: null,
    profitEmail: "",
    incomeTaxNumber: 0,
    timeZone: "America/New_York",
    currencies: currencies,
    showInitialProductCostImportPopup: false,
    myshopifyUrl: null,
    storeActive: true,
    storeCurrencyObject: {
      Code: "EUR",
      Name: "Euro Member Countries",
      Symbol: '€',
    },
    storeCurrencyObjectMeta: {
      Code: "EUR",
      Name: "Euro Member Countries",
      Symbol: '€',
    },
    meta: false,
    metaAccount: "",
    metaAccounts: [],
    metaAccountsError: false,
    storeRequest: false,
    cjDropshipping: false,
    metaCurrency: null,
    supplierCurrency: "USD",
    manualCurrency: null,
    storeName: "",
    operatingCostDaily: false,
    importTotal: false,
    importFeeEnabled: false,
    importFeeAmount: 2.50,
    importFeeStartDate: "2026-07-01",
    importFeeAllocation: "equal_line",
    firstImportOpen: false,
    missingProductCosts: {},
    bundleLoading: false,
    customRevenue: [],
    toHighRevenue: false,
  },
  getters: {
    currentCurrencySymbol: state => state.storeCurrencyObject?.Symbol ?? '€',
    currentCurrencySymbolMeta: state => state.storeCurrencyObjectMeta?.Symbol ?? '€'
  },
  mutations: {
    setWhopConnection(state, { shopName, enabled, hasHistory }) {
      state.whopShopName = shopName;
      state.whop = enabled === true;
      state.whopHasHistory = hasHistory === true;
    },
    setshowInitialProductCostImportPopup(state, data) {
      state.showInitialProductCostImportPopup = data ?? false
    },
    setProviders(state, providers) {
      state.paymentProviders = providers ?? [];
    },
    setcustomRevenue(state, customRevenue) {
      state.customRevenue = customRevenue ?? [];
    },
    setbundleLoading(state, data) {
      state.bundleLoading = data ?? false;
    },
    setStoreActive(state, data) {
      state.storeActive = data ?? true;
    },

    setMissingProductCosts(state, costs) {
      state.missingProductCosts = costs ?? {};
    },
    setMeta(state, data) {
      if (data) {
        state.metaAccount = data;
        state.meta = true
      }
    },
    setMetaAccountsError(state, failed) {
      state.metaAccountsError = failed;
    },
    setMetaAccounts(state, data) {

      state.metaAccounts = data ?? [];

    },
    setfilter(state, data) {
      state.filters = data ?? []
    },
    setnotification(state, data) {
      state.notifications = data ?? []
    },
    setStoreName(state, data) {
      state.storeName = data ?? false
    },
    setstoreRequest(state, data) {
      state.storeRequest = data ?? false
    },
    settoHighRevenue(state, data) {
      state.toHighRevenue = data ?? false
    },
    setmetaCurrency(state, data) {
      state.metaCurrency = data ?? null
    },
    setIncompleteData(state, data) {
      state.incompleteData = data ?? false
    },
    setRecPaymentfees(state, data) {
      state.recPaymentfees = data ?? false
    },
    setStoreCurrency(state, data) {
      state.storeCurrency = data ?? ""
    },
    setSecondaryCountries(state, data) {
      state.secondaryCountries = data ?? []
    },
    setMainCountry(state, data) {
      state.mainCountry = data ?? ""
    },
    setSupplierCurrency(state, data) {
      state.supplierCurrency = data ?? "USD"
    },
    setManualCurrency(state, data) {
      state.manualCurrency = data ?? null
    },
    setStoreCurrencyObject(state, data) {
      state.storeCurrencyObject = data ?? {
        Code: "EUR",
        Name: "Euro Member Countries",
        Symbol: '€',
      }
    },
    setStoreCurrencyObjectMeta(state, data) {
      state.storeCurrencyObjectMeta = data ?? {
        Code: "EUR",
        Name: "Euro Member Countries",
        Symbol: '€',
      }
    },
    setincomeTax(state, data) {
      state.incomeTax = data ?? 0
    },
    setTimeZone(state, data) {
      state.timeZone = data ?? "America/New_York"
    },
    setprofitEmail(state, data) {
      state.profitEmail = data ?? ""
    },
    setincomeTaxNumber(state, data) {
      state.incomeTaxNumber = data ?? 0
    },
    setdefaultMargin(state, data) {
      state.defaultMargin = data ?? null
    },
 
    setReload(state, data) {
      state.reloadData = data ?? false
    },
    setCurrentlyLoading(state, data) {
      state.currentlyLoading = data ?? false
    },
    setRecalculationJobRunning(state, data) {
      state.recalculationJobRunning = data ?? false
    },
    setRecalculationNeeded(state, data) {
      state.recalculationNeeded = data ?? false
    },
    setsubscriptionLevel(state, data) {
      state.subscriptionLevel = data ?? 0
    },
    setCj(state, data) {
      state.cjDropshipping = data ?? false
    },
    setimportTotal(state, data) {
      state.importTotal = data ?? false
    },
    setImportFeeSettings(state, data) {
      state.importFeeEnabled = data?.importFeeEnabled ?? false
      state.importFeeAmount = data?.importFeeAmount ?? 2.50
      state.importFeeStartDate = data?.importFeeStartDate ?? "2026-07-01"
      state.importFeeAllocation = data?.importFeeAllocation ?? "equal_line"
    },
    setfirstImportOpen(state, data) {
      state.firstImportOpen = data ?? false
    },
    setFreeTrial(state, data) {
      state.freeTrial = data ?? true
    },
    setMarketingWarning(state, data) {
      state.marketingWarning = data ?? false
    },
    setMarketingCost(state, marketing) {
      state.marketingCosts = marketing ?? {};
    },
    setProductCosts(state, productCosts) {
      state.productCosts = productCosts ?? {};
    },
    setProductCostsSecondary(state, productCosts) {
      state.secondaryProductCosts = productCosts ?? {};
    },
    setDateRange(state, currentDateRange) {
      state.currentDateRange = currentDateRange ?? {};
    },
    setDateMultiRange(state, currentDateRange) {
      state.currentMultiDateRange = currentDateRange ?? {};
    },
    updateProductCosts(state, productCost) {
      var key = Object.keys(productCost)[0];
      if (state.productCost == null) {
        state.productCost = {}
      }
      state.productCosts[key] = productCost[key];
    },
    setFixPayments(state, fixPayments) {
      state.fixPayments = fixPayments ?? [];
    },
    setLastLogin(state, lastLogin) {
      state.lastLogin = lastLogin;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions ?? [];
    },
    setOperatingCostDaily(state, value) {
      state.operatingCostDaily = value ?? false;
    },
    setMyshopifyUrl(state, value) {
      state.myshopifyUrl = value ?? null;
    },
  },
  actions: {
    GetPaymentProviders({ commit }) {
      console.log("fetching payment providers from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("payment-providers").doc(firebase.auth().currentUser.uid).get()
          .then(x => {
            resolve();
            commit('setProviders', x.data().providers)

          })
          .catch(e => { reject(e) })
      })
    },
    UpdatePaymentProviders({ commit, state, dispatch }, editrow) {
      var pproviders = JSON.parse(JSON.stringify(state.paymentProviders));
      var index = pproviders.findIndex(e => e.id == editrow.id);
      pproviders[index] = editrow;
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("payment-providers").doc(firebase.auth().currentUser.uid).set({ providers: pproviders })
          .then(_ => {
            dispatch('shopify/CaculationRequired', {}, { root: true })
            commit('setProviders', pproviders)
            resolve();
          })
          .catch(e => { reject(e) });
      })
    },
    reactivateStore({ commit, state, dispatch }) {

      return new Promise((resolve, reject) => {
        firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({ active: true }, { merge: true })
          .then(_ => {

            // load missing data


            dispatch('api/apiPostWithToken', {
              path: '/orderFetching-FetchNewOrdersInitialNew',
            }, { root: true }).then(x => {
              commit('setStoreActive', true)
              resolve();
            }).catch(error => {
              reject(error);
            });



          })
          .catch(e => { reject(e) });
      })
    },
    // Dismiss the marketing warning and persist the change to Firebase
    dismissMarketingWarning({ commit }) {
      return firebase.firestore()
        .collection("userdata")
        .doc(firebase.auth().currentUser.uid)
        .set({ marketingWarning: false }, { merge: true })
        .then(() => {
          commit("setMarketingWarning", false);
        });
    },
    InitialProviderSet({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-FetchInitialPaymentNew'
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetLastLogin({ commit, dispatch, rootState }) {
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid).get()
          .then(async x => {
            const dataX = x.data()
            commit('setWhopConnection', {
              shopName: x.id || firebase.auth().currentUser.uid,
              enabled: dataX?.whop === true,
              hasHistory: dataX?.whopHasHistory === true,
            })
            var lastLogin = dataX?.lastLogin ?? null;
            var incompleteData = dataX?.incompleteData ?? true;
            var subscriptionLevel = dataX?.subscriptionLevel ?? 0;
            var freeTrial = dataX?.freeTrial ?? true;
            var marketingWarning = dataX?.marketingWarning ?? false;
            var currency = dataX?.currency ?? ""
            var incomeTax = dataX?.incomeTax ?? 0
            var profitEmail = dataX?.email ?? ""
            var incomeTaxNumber = dataX?.incomeTaxNumber ?? 0
            var timeZone = dataX?.timezone ?? "America/New_York"
            var productCostImportPopUp = dataX?.productCostImportPopUp ?? true
            var secondaryCountries = dataX?.secondaryCountries ?? []
            var mainCountry = dataX?.mainCountry ?? ""
            var margin = dataX?.defaultMargin ?? null;
            var meta = dataX?.metaAccount ?? null;
            var cjDropshipping = dataX?.cjDropshipping ?? false;
            var supplierCurrency = dataX?.supplierCurrency ?? "USD";
            var manualCurrency = dataX?.manualCurrency ?? null;
            var finalOrderFetched = dataX?.finalOrderFetched ?? null
            var storeName = dataX?.storeName ?? firebase.auth().currentUser.uid
            var operatingCostDaily = dataX?.operatingCostDaily ?? false
            var importTotal = dataX?.importTotal ?? false
            var importFeeSettings = {
              importFeeEnabled: dataX?.importFeeEnabled ?? false,
              importFeeAmount: dataX?.importFeeAmount ?? 2.50,
              importFeeStartDate: dataX?.importFeeStartDate ?? "2026-07-01",
              importFeeAllocation: dataX?.importFeeAllocation ?? "equal_line",
            }
            var firstImportOpen = dataX?.firstImportOpen ?? true
            var customRev = dataX?.customRevenue ?? false
            var toHighRevenue = dataX?.toHighRevenue ?? false
            var storeActive = dataX?.active ?? true
            var reloadInProgress = dataX?.currentlyLoading ?? false
            var reloadNecessary = dataX?.reloadNecessary ?? false
            var recalculationJobRunning = isManualRecalculationJobRunning(
              dataX?.manualRecalculationJob
            )

            const hasShopifyAccessToken = Boolean(rootState.api?.shopify_access_code)
            if (hasShopifyAccessToken) {
              dispatch("getStoreRequest", "").catch(() => {
                commit("setstoreRequest", false)
              });
            }
            dispatch('CheckAutomaticAssingment', dataX);
            var cur = await dispatch('SetCurrencySymbol', currency);

            commit("setCurrentlyLoading", reloadInProgress)
            commit("setRecalculationJobRunning", recalculationJobRunning)
            commit("setRecalculationNeeded", reloadNecessary)
            commit("setCj", cjDropshipping)
            commit("setStoreActive", storeActive)
            commit("settoHighRevenue", toHighRevenue)
            commit("setincomeTax", incomeTax)
            commit("setSecondaryCountries", secondaryCountries)
            commit("setMainCountry", mainCountry)
            commit("setSecondaryCountries", secondaryCountries)
            commit("setTimeZone", timeZone)
            commit("setprofitEmail", profitEmail)
            commit("setincomeTaxNumber", incomeTaxNumber)
            commit("setIncompleteData", incompleteData)
            commit("setsubscriptionLevel", subscriptionLevel)
            commit("setFreeTrial", freeTrial)
            commit("setMarketingWarning", marketingWarning)
            commit("setStoreCurrency", currency)
            commit("setStoreCurrencyObject", cur)
            commit("setimportTotal", importTotal)
            commit("setImportFeeSettings", importFeeSettings)
            commit("setfirstImportOpen", firstImportOpen)

            commit("setSupplierCurrency", supplierCurrency)
            commit("setManualCurrency", manualCurrency)
            commit("setLastLogin", lastLogin)
            commit("setshowInitialProductCostImportPopup", productCostImportPopUp)
            commit("setdefaultMargin", margin)
            commit("setMeta", meta)
            commit("setOperatingCostDaily", operatingCostDaily)

            commit("setStoreName", storeName)
            commit("setMyshopifyUrl", firebase.auth().currentUser.uid)


            if (meta) {
              dispatch("getMetaAccounts", meta).catch(() => {
                commit("setMetaAccounts", [])
                commit("setmetaCurrency", null)
              })
            }

            if (subscriptionLevel == 3) {
              dispatch("GetFilters")
            }

            if (customRev) {
              dispatch("getCustomRevenue", "");
            }

            await dispatch('SetLastLogin');

            if (!finalOrderFetched) {
              lastLogin = null;
            }
            resolve(lastLogin);
          })
          .catch(e => { reject(e) })
      })
    },
    async GetFilters({ commit, state }) {


      const docRef = firebase
        .firestore()
        .collection("advancedFilters")
        .doc(firebase.auth().currentUser.uid)
        .collection("filters")

      return new Promise((resolve, reject) => {
        docRef
          .get()
          .then((querySnapshot) => {
            let filter = [];
            querySnapshot.forEach((doc) => {
              filter.push({ id: doc.id, ...doc.data() });
            });
            commit("setfilter", filter);
            resolve();
          })
          .catch((e) => {
            console.log("error fetching filters", e)
            reject(e);
          });
      });
    },
    async Getnotifications({ commit, state }) {


      const docRef = firebase
        .firestore()
        .collection("notifications")
        .doc(firebase.auth().currentUser.uid)
        .collection("notification")

      return new Promise((resolve, reject) => {
        docRef
          .get()
          .then((querySnapshot) => {
            let notification = [];
            querySnapshot.forEach((doc) => {
              notification.push({ id: doc.id, ...doc.data() });
            });

            commit("setnotification", notification);
            resolve();
          })
          .catch((e) => {
            console.log("error fetching notifications", e)
            reject(e);
          });
      });
    },
    async deleteNotification({ commit, dispatch }, id) {
      console.log("delete revenue custom")
      return new Promise((resolve, reject) => {

        firebase.firestore()
          .collection('notifications')
          .doc(firebase.auth().currentUser.uid)
          .collection("notification")
          .doc(id)
          .delete()
          .then(() => {
            resolve();
            // Document deleted successfully
          })
          .catch((error) => {
            reject()
            console.error("Error getting documents: ", error);
          });



        // multiStoreCalc-TestMulti

      })
    },
    SetCurrencySymbol({ state }, currency) {
      var currencyObject = {
        Code: "EUR",
        Name: "Euro Member Countries",
        Symbol: '€',
      }
      try {
        const currencyDetail = state.currencies.find(curr => curr.Code === currency);
        currencyObject = currencyDetail || {
          Code: "EUR",
          Name: "Euro Member Countries",
          Symbol: '€',
        }
      } catch (e) {
        console.log("error defining currency object", e)
      }

      return currencyObject
    },
    async GetCurrencyRatesForRange({}, data) {
      const start = moment(data?.start).startOf('day');
      const end = moment(data?.end).startOf('day');
      const ratesByDate = {};

      if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
        return ratesByDate;
      }

      const monthKeys = [];
      const monthCursor = start.clone().startOf('month');
      while (monthCursor.isSameOrBefore(end, 'month')) {
        monthKeys.push(monthCursor.format('YYYY|MM'));
        monthCursor.add(1, 'month');
      }

      for (const monthKey of monthKeys) {
        try {
          // Expected schema: currency/conversion/{YYYY|MM}/rates with fields "1", "2", ... "31"
          const monthRatesRef = firebase.firestore().collection('currency').doc('conversion').collection(monthKey).doc('rates');
          const monthRatesDoc = await monthRatesRef.get();

          if (monthRatesDoc.exists) {
            const monthData = monthRatesDoc.data() ?? {};
            let dayCursor = start.clone().startOf('day');
            while (dayCursor.isSameOrBefore(end, 'day')) {
              if (dayCursor.format('YYYY|MM') === monthKey) {
                const dayKey = String(dayCursor.date());
                const dayKeyPadded = dayCursor.format('DD');
                const dayRates = monthData?.[dayKey] ?? monthData?.[dayKeyPadded];
                if (dayRates && typeof dayRates === 'object') {
                  ratesByDate[dayCursor.format('DD-MM-YYYY')] = dayRates;
                }
              }
              dayCursor.add(1, 'day');
            }
            continue;
          }

          // Fallback schema: currency/conversion/{YYYY|MM}/{dayDocId}
          const daysSnapshot = await firebase.firestore().collection('currency').doc('conversion').collection(monthKey).get();
          daysSnapshot.forEach(docSnap => {
            const docData = docSnap.data() ?? {};
            const dayRates = docData?.rates ?? docData;
            const dayNumber = parseInt(docSnap.id, 10);
            if (Number.isNaN(dayNumber)) return;
            const dateKey = `${String(dayNumber).padStart(2, '0')}-${monthKey.split('|')[1]}-${monthKey.split('|')[0]}`;
            ratesByDate[dateKey] = dayRates;
          });
        } catch (e) {
          console.log("error fetching conversion rates for month", monthKey, e);
        }
      }

      return ratesByDate;
    },

    async CheckAutomaticAssingment({ state, dispatch }, data) {
      const facebook = data?.facebook ?? false
      const pinterest = data?.pinterest ?? false
      const google = data?.google ?? false
      const snapchat = data?.snapchat ?? false
      const tiktok = data?.tiktok ?? false
      const cj = data?.cjDropshipping ?? false
      const currentDateRaw = moment();
      const currentDate = currentDateRaw.subtract(1, 'days');

      if (cj == true) {
        console.log("start automatic cj assignment")
        try {
          dispatch('api/apiPostWithToken', {
            path: '/userdata-CalculateDailyProductCostAutomaticNew', body: {}
          }, { root: true }).then(x => {

          }).catch(error => {
            reject(error);
          });
        } catch (e) {
          console.log("error automatic cjdropshipping assignment", e, firebase.auth().currentUser.uid)
        }

      }

      if (pinterest == true) {
        const lastPinterestAssignment = data?.lastPinterestAssignment ?? null
        if (lastPinterestAssignment) {
          const date = moment(lastPinterestAssignment);
          // Compare if the parsed date is before today
          if (date.isBefore(currentDate, 'day')) {
            try {
              var pinterestRes = await dispatch('AutoAssignPinterest', "{}");
            } catch (e) {
              console.log("error auto Assign pinterest object", e)
            }
          }
        }
      }

      if (snapchat == true) {
        const lastSnapChatAssignment = data?.lastSnapChatAssignment ?? null
        if (lastSnapChatAssignment) {
          const date = moment(lastSnapChatAssignment);
          // Compare if the parsed date is before today
          if (date.isBefore(currentDate, 'day')) {
            try {
              var snapchatRes = await dispatch('AutoAssignSnapChat', "{}");
            } catch (e) {
              console.log("error auto Assign snapchat object", e)
            }
          }
        }
      }

      if (tiktok == true) {
        const lastTikTokAssignment = data?.lastTikTokAssignment ?? null
        if (lastTikTokAssignment) {
          const date = moment(lastTikTokAssignment);
          // Compare if the parsed date is before today
          if (date.isBefore(currentDate, 'day')) {
            try {
              var snapchatRes = await dispatch('AutoAssignTiktok', "{}");
            } catch (e) {
              console.log("error auto Assign tikotk object", e)
            }
          }
        }
      }

      if (facebook == true) {
        const lastFacebookAssignment = data?.lastFacebookAssignment ?? null
        if (lastFacebookAssignment) {
          const date = moment(lastFacebookAssignment);
          // Compare if the parsed date is before today
          if (date.isBefore(currentDate, 'day')) {
            try {
              var snapchatRes = await dispatch('AutoAssignFacebook', "{}");
            } catch (e) {
              console.log("error auto Assign facebook object", e)
            }
          }
        }

      }

      return ""
    },
    SetUserDataGeneral({ commit }, userDataG) {
      commit("setincomeTax", userDataG.incomeTax)
      commit("setprofitEmail", userDataG.email)
      commit("setincomeTaxNumber", userDataG.incomeTaxNumber)
    },
    SetDefaultMarginGeneral({ commit }, margin) {
      commit("setdefaultMargin", margin)
    },
    SetStoreName({ commit }, name) {
      commit("setStoreName", name)
    },
    SetLastLogin({ commit }) {
      return firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({ lastLogin: moment().format() }, { merge: true })
    },
    SetSupplierCurrency({ commit }, currency) {

      commit("setSupplierCurrency", currency)
      return firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({ supplierCurrency: currency }, { merge: true })
    },
    SetImportFeeSettings({ commit }, settings) {
      commit("setImportFeeSettings", settings)
    },
    UpdateImportFeeSettings({ commit }, settings) {
      const parsedAmount = parseFloat(String(settings?.importFeeAmount ?? "").replace(',', '.'))
      const allowedAllocations = ["equal_line", "quantity", "revenue"]
      const importFeeSettings = {
        importFeeEnabled: settings?.importFeeEnabled === true,
        importFeeAmount: Number.isFinite(parsedAmount) ? parsedAmount : 0,
        importFeeStartDate: settings?.importFeeStartDate || "2026-07-01",
        importFeeAllocation: allowedAllocations.includes(settings?.importFeeAllocation) ? settings.importFeeAllocation : "equal_line",
      }

      return firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({
        ...importFeeSettings,
        reloadNecessary: true,
        reloadProductCost: true,
        reloadAllProductCost: true,
      }, { merge: true }).then(() => {
        commit("setImportFeeSettings", importFeeSettings)
        commit("setRecalculationNeeded", true)
      })
    },
    SetManualCurrency({ commit }, currency) {

      commit("setManualCurrency", currency)
      return firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({ manualCurrency: currency }, { merge: true })
    },

    async getMetaAccounts({ commit, dispatch }, meta) {
      commit("setMetaAccountsError", false)
      try {
        const response = await dispatch('api/apiPostWithToken', {
          path: '/shopify-getMetaStores', body: { data: meta }
        }, { root: true })
        const accounts = response.data?.resArray
        if (!Array.isArray(accounts) || accounts.length === 0) {
          throw new Error("No connected stores were returned for this multi-store account.")
        }
        const currency = response.data?.metaCurrency ?? null
        const currencyObject = await dispatch('SetCurrencySymbol', currency)
        commit("setmetaCurrency", currency)
        commit("setStoreCurrencyObjectMeta", currencyObject)
        commit("setMetaAccounts", accounts)
        return response.data
      } catch (error) {
        commit("setMetaAccounts", [])
        commit("setmetaCurrency", null)
        commit("setMetaAccountsError", true)
        throw error
      }
    },
    ChangeUser({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-changeUser', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    SetProductPopUp({ commit }) {
      commit("setshowInitialProductCostImportPopup", false)
      return firebase.firestore().collection("userdata").doc(firebase.auth().currentUser.uid).set({ productCostImportPopUp: false }, { merge: true })
    },
    RequestBilling({ dispatch }, discount) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/billing-RequestBilling',
          body: { shopName: shopName, freeTrial: this.state.freeTrial, affiliateCode: discount.affiliateCode, discount: discount.value, plan: discount.plan }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    confirmBilling({ dispatch }, chargeID) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/billing-checkBilling',
          body: { shopName: shopName, chargeID: chargeID }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    cancelBilling({ dispatch }) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/billing-cancelBilling',
          body: { shopName: shopName }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    checkDiscount({ dispatch }, code) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/billing-discountCheck',
          body: { shopName: shopName, code: code }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    // Cost per product
    GetProductCosts({ dispatch, commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/userdata-GetProductCostAdditionals',

        }, { root: true }).then(x => {
          let data = x.data
          commit("setProductCosts", data)
          resolve(data);

          resolve(data)
        }).catch(error => {
          reject(error);
        });
      })
      // return new Promise((resolve, reject) => {


      //   GetProductCostAdditionals
      //   firebase.firestore().collection("product-additionals").doc(firebase.auth().currentUser.uid).get()
      //     .then(x => {
      //       let data = x.data();
      //       commit("setProductCosts", data)
      //       resolve(data);
      //     })
      //     .catch(e => { reject(e) })
      // })
    },

    GetProductCostsSecondary({ commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("product-additionals").doc(firebase.auth().currentUser.uid).collection("secondaryCountries").doc("secondaryCountries").get()
          .then(x => {
            let data = x.data();
            commit("setProductCostsSecondary", data)
            resolve(data);
          })
          .catch(e => { reject(e) })
      })
    },

    GetProductCostsCustomBundle({ commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("product-additionals").doc(firebase.auth().currentUser.uid).collection("customBundle").doc("customBundle").get()
          .then(x => {
            let data = x.data();
            resolve(data);
          })
          .catch(e => { reject(e) })
      })
    },

    GetProductDigital({ commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("product-additionals").doc(firebase.auth().currentUser.uid).collection("digitalProducts").doc("digitalProducts").get()
          .then(x => {
            let data = x.data();
            resolve(data);
          })
          .catch(e => { reject(e) })
      })
    },

    GetFacebookCampaigns({ dispatch }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        console.log('Get Facebook Campagins --')
        dispatch('api/apiPostWithToken', {
          path: '/facebook-GetCampaigns', body: {}
        }, { root: true }).then(x => {
          console.log("x", x.data)
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },
    SetFacebookCampaigns({ dispatch }, data) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        console.log('Set Facebook Campagins --')
        dispatch('api/apiPostWithToken', {
          path: '/facebook-SetCampaigns', body: data
        }, { root: true }).then(x => {
          console.log("x", x.data)
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },
    DeleteFacebookCampaigns({ dispatch }, data) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        console.log('Delet Facebook Campagins --')
        dispatch('api/apiPostWithToken', {
          path: '/facebook-DeleteCampaigns', body: data
        }, { root: true }).then(x => {
          console.log("x", x.data)
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },


    GetMissingProductCosts({ commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("product-additionals").doc(firebase.auth().currentUser.uid).collection("secondaryCountries").doc("missingProductCost").get()
          .then(x => {
            let data = x.data();
            commit("setMissingProductCosts", data)
            resolve(data);
          })
          .catch(e => { reject(e) })
      })
    },
    SetDateRange({ commit }, data) {
      commit("setDateRange", data)
    },
    SetDateMultiRange({ commit }, data) {
      commit("setDateMultiRange", data)
    },
    SetreloadData({ commit }, data) {
    
      commit("setReload", data)
    },
    SetcurrentlyLoading({ state, commit }, data) {

      if(state.currentlyLoading == true && data == false) {
        console.log("initiate reload")
        commit("setReload", true)
      }
    
      commit("setCurrentlyLoading", data)
    },

    SetRecalculationNeeded({ commit }, data) {
    
      commit("setRecalculationNeeded", data)
    },

    SetIncompleteData({ commit }, data) {
      commit("setIncompleteData", data)
    },
    SetRecPaymentfees({ commit }, data) {
      commit("setRecPaymentfees", data)
    },

    // Cost per product
    GetProductCostsForProduct({ }, ids) {
      console.log("fetching targeted product costs for specific product from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('product').doc(firebase.auth().currentUser.uid).collection(ids.productid.toString()).doc('product').get()
          .then(x => {
            var product = x.data();
            resolve(product.variants.find(x => x.id == ids.variantid)?.productCost)
          })
          .catch(e => { reject(e) })
      })
    },

    // Requires this object:
    //{
    //    id: 45007419572508, (variant id)
    //    cost1: 80, (these three could be omitted, but you have to have at least 1 cost defined)
    //    cost2: 90,
    //    cost3: 40,
    //    pid: 8236031213852, (product id)
    //    initial: true,
    //    startDate: '2023-04-28T18:31:07+02:00'
    //    endDate: '2023-06-28T18:31:07+02:00' (Optional, if hidden it will count as the current productcost)
    //  }
    async UpdateProductCost({ dispatch, commit }, productCost) {
      return new Promise((resolve, reject) => {
        console.log('setting productcosts')
        dispatch('api/apiPostWithToken', {
          path: '/userdata-SetProductCost', body: productCost
        }, { root: true }).then(x => {
          resolve()
        }).catch(error => {
          reject(error);
        });
      });
    },
    async UpdateProductCostBulk({ dispatch, commit }, productCost) {
      return new Promise((resolve, reject) => {
        console.log('setting productcosts')
        dispatch('api/apiPostWithToken', {
          path: '/userdata-SetProductCostBulk', body: productCost
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },

    async DeleteProductCost({ dispatch, commit }, productCost) {
      return new Promise((resolve, reject) => {
        console.log('deleting productcosts')
        dispatch('api/apiPostWithToken', {
          path: '/userdata-DeleteProductCost', body: productCost
        }, { root: true }).then(x => {
          resolve()
        }).catch(error => {
          reject(error);
        });
      });
    },

    async ProductCostCalculation({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        console.log('calculating product cost')
        dispatch('api/apiPostWithToken', {
          path: '/userdata-CalculateNewProductCostNew',
        }, { root: true }).then(x => {
          resolve()
        }).catch(error => {
          reject(error);
        });
      });
    },

    async FetchNewBundlesInitial({ dispatch, commit }, data) {
      let shopName = firebase.auth().currentUser.uid

      console.log("test the new bundle log")
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/orderFetching-FetchFirstTimeBundleAnalytics', body: { shopName: shopName }
        }, { root: true })
        resolve("started")
      })
    },

    async ImportProductCostCalculation({ dispatch, commit }, orderData) {
      return new Promise((resolve, reject) => {
        console.log('importing productcosts preparation')
        dispatch('api/apiPostWithToken', {
          path: '/userdata-ImportProductCostCalculationsNew', body: orderData
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },

    async ConfirmImportProductCost({ dispatch, commit }, productCosts) {
      return new Promise((resolve, reject) => {
        console.log('confirmImprt')

        dispatch('api/apiPostWithToken', {
          path: '/userdata-CalculateNewProductCostAutomaticNew', body: productCosts
        }, { root: true }).then(x => {
        }).catch(error => {
          reject(error);
        });

        dispatch('api/apiPostWithToken', {
          path: '/userdata-ConfirmProductCostImport', body: productCosts
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });
    },
    async productCostMarginChangeAll({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        console.log('recalulate all product cost')

        dispatch('api/apiPostWithToken', {
          path: '/userdata-CalculateNewProductCostAutomaticNew', body: { all: true }
        }, { root: true }).then(x => {
        }).catch(error => {
          reject(error);
        });


      });
    },
    async ConnectPinterest({ dispatch, commit }, mode) {

      try {
        const response = await dispatch('api/apiGetWithToken', { path: '/pinterest-RequestPinterestIntegration' }, { root: true });
        const authUrl = response.data.authUrl;


        const authWindow = window.open(authUrl, 'pinterest-auth', 'width=500,height=500');
        var authCode = "";
        await new Promise((resolve, reject) => {
          const checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkUrlChange);
              console.log("Authentication window closed");
              reject(new Error("Authentication window closed"));
              return;
            }

            if (authWindow.location.href !== authUrl && authWindow.location.href != "about:blank") {
              clearInterval(checkUrlChange);
              const newUrl = authWindow.location.href;
              console.log("URL changed to:", newUrl);
              authCode = newUrl.substring(newUrl.indexOf('=') + 1);
              console.log("Authorization code:", authCode);
              resolve();
            }
          }, 1000); // Check every 1 second
        });

        if (authCode != null) {
          authWindow.close();
          var modeData = { authCode: authCode, mode: mode }
          const data = await dispatch('GetPinterestTokens', modeData);
          return data;
        } else {
          console.log("error getting Authcode");
          authWindow.close();
          return null;
        }

      } catch (error) {
        console.error('Error:', error.response.status, error.response.statusText);
        throw error;
      }

    },
    async ConnectPinterestTwo({ dispatch, commit }, mode) {

      try {
        const response = await dispatch('api/apiGetWithToken', { path: '/pinterest-RequestPinterestIntegration' }, { root: true });
        const authUrl = response.data.authUrl;


        const authWindow = window.open(authUrl, 'pinterest-auth', 'width=500,height=500');
        var authCode = "";
        await new Promise((resolve, reject) => {
          const checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkUrlChange);
              console.log("Authentication window closed");
              reject(new Error("Authentication window closed"));
              return;
            }

            if (authWindow.location.href !== authUrl && authWindow.location.href != "about:blank") {
              clearInterval(checkUrlChange);
              const newUrl = authWindow.location.href;
              console.log("URL changed to:", newUrl);
              authCode = newUrl.substring(newUrl.indexOf('=') + 1);
              console.log("Authorization code:", authCode);
              resolve();
            }
          }, 1000); // Check every 1 second
        });

        if (authCode != null) {
          authWindow.close();
          var modeData = { authCode: authCode, mode: mode }
          const data = await dispatch('GetPinterestTokensTwo', modeData);
          return data;
        } else {
          console.log("error getting Authcode");
          authWindow.close();
          return null;
        }

      } catch (error) {
        console.error('Error:', error.response.status, error.response.statusText);
        throw error;
      }

    },

    async ConnectFacebook({ dispatch }, mode) {
      const operationId = beginFacebookDiagnostic();
      let stage = 'popup';
      const startedAt = Date.now();
      const report = (event, extra = {}) => reportDiagnostic({ source: 'facebook', event, operationId, stage,
        durationMs: Date.now() - startedAt, ...extra });
      report('flow_started');
      // Reserve the popup while the browser still considers this a user click.
      const authWindow = window.open('about:blank', 'facebook-auth', 'width=500,height=500');
      if (!authWindow) {
        report('flow_failed', { reason: 'popup_blocked' });
        throw new Error('Facebook popup blocked. Please allow popups and try again.');
      }

      report('popup_opened');
      let checkUrlChange;
      try {
        stage = 'login_url';
        const response = await dispatch('api/apiGetWithToken', { path: '/facebook-authenticateWithFacebook' }, { root: true });
        const authUrl = new URL(response.data);
        const redirectUrl = new URL(authUrl.searchParams.get('redirect_uri'));
        report('login_url_received');
        stage = 'facebook_login';
        authWindow.location.href = authUrl.href;
        const authCode = await new Promise((resolve, reject) => {
          checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              reject(new Error('Authentication window closed'));
              return;
            }
            if (Date.now() - startedAt >= 5 * 60 * 1000) {
              reject(new Error('Facebook authentication timed out. Please try again.'));
              return;
            }

            let callbackUrl;
            try {
              const href = authWindow.location.href;
              if (href === 'about:blank') return;
              callbackUrl = new URL(href);
            } catch (error) {
              // Facebook remains cross-origin until it returns to our callback.
              if (error.name === 'SecurityError') return;
              reject(error);
              return;
            }
            if (callbackUrl.origin !== redirectUrl.origin || callbackUrl.pathname !== redirectUrl.pathname) return;
            stage = 'callback';
            report('callback_received');
            if (callbackUrl.searchParams.has('error')) {
              reject(new Error('Facebook authorization was declined or denied. Please try again.'));
              return;
            }
            const code = callbackUrl.searchParams.get('code');
            if (!code) {
              reject(new Error('Facebook did not return an authorization code. Please try again.'));
              return;
            }
            resolve(code);
          }, 500);
        });
        clearInterval(checkUrlChange);
        checkUrlChange = undefined;
        authWindow.close();
        stage = 'token_exchange';
        report('exchange_started');
        const accounts = await dispatch(mode === 'second' ? 'GetFacebookTokensTwo' : 'GetFacebookTokens', authCode);
        stage = 'accounts';
        report('accounts_received', { accountCount: Array.isArray(accounts) ? accounts.length : 0,
          reason: Array.isArray(accounts) && accounts.length ? undefined : 'empty_accounts', durationMs: Date.now() - startedAt });
        return accounts;
      } catch (error) {
        report('flow_failed', { reason: diagnosticReason(error), errorType: error?.name, durationMs: Date.now() - startedAt });
        throw error;
      } finally {
        if (checkUrlChange !== undefined) clearInterval(checkUrlChange);
        if (!authWindow.closed) authWindow.close();
      }
    },
    async getFacebookAccounts({ dispatch }) {

      return new Promise((resolve, reject) => {
        console.log('get facebook accounts')
        dispatch('api/apiPostWithToken', {
          path: '/facebook-getAccounts',
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      });

    },

    async ConnectSnapchat({ dispatch, commit }) {

      try {
        console.log("Snapchat start")
        const response = await dispatch('api/apiGetWithToken', { path: '/snapchat-authenticateWithSnapchat' }, { root: true });
        const authUrl = response.data;
        var authCode = "";

        console.log(response)
        const authWindow = window.open(authUrl, 'snapchat-auth', 'width=500,height=500');

        await new Promise((resolve, reject) => {
          const checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkUrlChange);
              console.log("Authentication window closed");
              reject(new Error("Authentication window closed"));
              return;
            }

            if (authWindow.location.href !== authUrl && authWindow.location.href != "about:blank") {
              clearInterval(checkUrlChange);
              const newUrl = authWindow.location.href;
              console.log("URL changed to:", newUrl);
              authCode = newUrl.substring(newUrl.indexOf('=') + 1);
              console.log("Authorization code:", authCode);
              resolve();
            }
          }, 1000); // Check every 1 second
        });
        console.log("Now access Snapchat API")
        if (authCode != null) {
          authWindow.close();
          const data = await dispatch('GetSnapchatTokens', authCode);
          return data;
        } else {
          console.log("error getting Authcode");
          authWindow.close();
          return null;
        }

      } catch (error) {
        console.error('Error:', error.response.status, error.response.statusText);
        throw error;
      }

    },

    async ConnectGoogle({ dispatch, commit }) {

      try {
        console.log("Google start")
        const response = await dispatch('api/apiGetWithToken', { path: '/google-authenticateWithGoogle' }, { root: true });
        console.log("okay - should be fine by now")
        console.log(response)
        const authUrl = response.data;
        var authCode = "";


        const authWindow = window.open(authUrl, 'google-auth', 'width=500,height=500');

        await new Promise((resolve, reject) => {
          const checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkUrlChange);
              console.log("Authentication window closed");
              reject(new Error("Authentication window closed"));
              return;
            }

            if (authWindow.location.href !== authUrl && authWindow.location.href != "about:blank") {
              clearInterval(checkUrlChange);
              const newUrl = authWindow.location.href;
              console.log("URL changed to:", newUrl);
              authCode = newUrl.substring(newUrl.indexOf('=') + 1);
              console.log("Authorization code:", authCode);
              resolve();
            }
          }, 1000); // Check every 1 second
        });
        console.log("Now access Google API")
        if (authCode != null) {
          authWindow.close();
          const data = await dispatch('GetGoogleTokens', authCode);
          console.log("check google", data)
          return data;
        } else {
          console.log("error getting access token");
          authWindow.close();
          return null;
        }

      } catch (error) {
        console.error('Error:', error.response.status, error.response.statusText);
        throw error;
      }

    },

    async ConnectTiktok({ dispatch, commit }) {

      try {
        console.log("Tiktok start")
        const response = await dispatch('api/apiGetWithToken', { path: '/tiktok-authenticateWithTiktok' }, { root: true });
        console.log("okay - should be fine by now")
        console.log(response)
        const authUrl = response.data;
        var authCode = "";


        const authWindow = window.open(authUrl, 'tiktok-auth', 'width=500,height=500');

        await new Promise((resolve, reject) => {
          const checkUrlChange = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkUrlChange);
              console.log("Authentication window closed");
              reject(new Error("Authentication window closed"));
              return;
            }


            if (authWindow.location.href !== authUrl && authWindow.location.href != "about:blank") {
              clearInterval(checkUrlChange);
              const newUrl = authWindow.location.href;
              console.log("URL changed to:", newUrl);
              authCode = newUrl.split('=')[1].split('&')[0];
              // authCode = newUrl.substring(newUrl.indexOf('=') + 1);

              console.log("Authorization code:", authCode);
              resolve();
            }
          }, 1000); // Check every 1 second
        });

        if (authCode != null) {
          authWindow.close();

          const data = await dispatch('GetTiktokTokens', authCode);
          console.log("check tiktok", data)
          return data;
        } else {
          console.log("error getting access token");
          authWindow.close();
          return null;
        }

      } catch (error) {
        console.error('Error:', error.response.status, error.response.statusText);
        throw error;
      }

    },

    DisconnectMarketingPlatform({ dispatch }, platform) {
      if (!platform) {
        return Promise.reject(new Error("No platform specified for disconnect"));
      }

      const updatePayload = { [platform]: false };

      return firebase.firestore()
        .collection('userdata')
        .doc(firebase.auth().currentUser.uid)
        .set(updatePayload, { merge: true })
        
    },


    GetFacebookTokens({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-facebookCallback', body: {
            authCode: data,
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    GetFacebookTokensTwo({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-facebookCallbackSecondAccount', body: {
            authCode: data,
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },



    GetPinterestTokens({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/pinterest-GetPinterestToken', body: {
            data,
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetPinterestTokensTwo({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/pinterest-GetPinterestTokenTwo', body: {
            data,
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    GetSnapchatTokens({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/snapchat-snapchatCallback', body: {
            authCode: data,
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetGoogleTokens({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/google-googleCallback', body: {
            authCode: data,
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetTiktokTokens({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/tiktok-tiktokCallback', body: {
            authCode: data,
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    SelectPinterestAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/pinterest-SelectedPinterestAdAccount', body: {
            adAccountID: data.adAccountID,
            currency: data.currency,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    SelectPinterestAdAccountTwo({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/pinterest-SelectedPinterestAdAccountTwo', body: {
            adAccountID: data.adAccountID,
            currency: data.currency,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    async getGoogleAccounts({ dispatch }, forceRefresh = false) {
      const currentUser = firebase.auth().currentUser;
      if (!currentUser) {
        throw new Error("Firebase session is unavailable");
      }

      const firebaseIdToken = await currentUser.getIdToken(forceRefresh === true);
      const response = await dispatch('api/apiPostWithToken', {
        path: '/google-getAccounts',
        headers: {
          Authorization: `Bearer ${firebaseIdToken}`,
          'Content-Type': 'application/json',
        },
      }, { root: true });

      return response.data;
    },

    SelectGoogleAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        const body = Array.isArray(data.adAccounts) ? {
          mode: data?.mode ?? "",
          adAccounts: data.adAccounts.map(account => ({
            id: account.id,
            parent: account.parent,
          })),
        } : {
          adAccountID: data.adAccountID,
          mode: data?.mode ?? "",
          parent: data?.parent ?? null,
        }

        dispatch('api/apiPostWithToken', {
          path: '/google-SelectGoogleAdAccountNew', body
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    SelectTiktokAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/tiktok-SelectTiktokAdAccount', body: {
            adAccountID: data.adAccountID,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    SelectFacebookAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-SelectFacebookAdAccountNew', body: {
            adAccountID: data.adAccountID,
            adAccountID2: data.adAccountID2,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    SelectAdditionalFacebookAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-SelectFacebookAdAccountNewAdditional', body: {
            adAccountID: data.adAccountID,
            adAccountID2: data.adAccountID2,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    DeSelectAdditionalFacebookAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-DeSelectFacebookAdAccountNewAdditional', body: {
            adAccountID: data.adAccountID,
            adAccountID2: data.adAccountID2,
            mode: data?.mode ?? "",
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    SelectSnapchatAdAccount({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/snapchat-SelectSnapchatAdAccount', body: data
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    confirmChangeMainStore({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/billing-changeMainStore', body: {
            newMetaAccount: data,
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    saveCJ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/cjDropshipping-saveCJ', body: data
        }, { root: true }).then(x => {

          if (x.data == "success") {
            commit("setCj", true)


            dispatch('api/apiPostWithToken', {
              path: '/cjDropshipping-firstImport', body: {}
            }, { root: true }).then(x => {

            }).catch(error => {
              reject(error);
            });


            dispatch('api/apiPostWithToken', {
              path: '/userdata-CalculateNewProductCostAutomaticNew', body: {}
            }, { root: true }).then(x => {

            }).catch(error => {
              reject(error);
            });
          }

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    saveCJforConnectedStore({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/cjDropshipping-saveCJforConnectedStore', body: data
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },


    deactivateCJ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/cjDropshipping-deactivateCJ', body: data
        }, { root: true }).then(x => {
          commit("setCj", false)
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    AutoAssignPinterest({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/pinterest-AutoAssignNewAds', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    AutoAssignSnapChat({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/snapchat-AutoAssignNewAds', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    AutoAssignTiktok({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/tiktok-AutoAssignNewAds', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    AutoAssignFacebook({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/facebook-AutoAssignNewAdsNew', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    recalculateTwoMonth({ commit, dispatch }) {
      console.log("Test is send")
      // Show the running state immediately. Firestore remains the source of truth
      // and will clear it through the authenticated layout's live listener.
      commit("setCurrentlyLoading", true)
      commit("setRecalculationJobRunning", true)
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/admin-ResetStore', body: {}
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          commit("setCurrentlyLoading", false)
          commit("setRecalculationJobRunning", false)
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    ReloadStoreMonth({ commit, dispatch }, data) {
      console.log("Test is send")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-ResetStore', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    TestOrders({ commit, dispatch }, data) {
      console.log("Test is send")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-TestOrders', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    TestOrders({ commit, dispatch }, data) {
      console.log("Test is send")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-TestTotalNumbers', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    TestDesiredTesting({ commit, dispatch }, data) {
      console.log("Test Desired is send")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-TestDesiredBehavior', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getOrdersCSV({ commit, dispatch }, data) {
      console.log("Test Desired is send")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-getOrdersCSV', body: {}
        }, { root: true }).then(x => {
          resolve(x);
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    activateWebhookDeinstall({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/billing-addWebhookDeinstall', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    activateCrossVariant({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-SetCrossVariantCosts', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    saveCustomRevenue({ commit, dispatch }, data) {
      console.log("save custom revneue")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/admin-saveCustomRevenue', body: data
        }, { root: true }).then(x => {
          resolve()
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    setNeedReclac({ commit, dispatch }) {
      console.log("mark data to be recalculated");
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('userdata')
          .doc(firebase.auth().currentUser.uid)
          .set({ reloadNecessary: true }, { merge: true })
          .then(() => {
            // Corrected: Pass 'true' directly.
            commit("setRecalculationNeeded", true);
            resolve();
          })
          .catch((error) => {
            console.error("Error getting documents: ", error);
            reject(error);
          });
      });
    },
    
    getCustomRevenue({ commit, dispatch }) {
      console.log("fetching custom revenue")
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('custom-revenue')
          .doc(firebase.auth().currentUser.uid)
          .collection("revenue")
          .get()
          .then((querySnapshot) => {
            let documentsArray = [];
            querySnapshot.forEach((doc) => {
              documentsArray.push({
                id: doc.id,
                ...doc.data()
              });
            });

            commit('setcustomRevenue', documentsArray)
            resolve(documentsArray);
            // Now you can use documentsArray as needed
          })
          .catch((error) => {
            console.error("Error getting documents: ", error);
          });


      })
    },
    deleteRevenue({ commit, dispatch }, id) {
      console.log("delete revenue custom")
      return new Promise((resolve, reject) => {

        firebase.firestore()
          .collection('custom-revenue')
          .doc(firebase.auth().currentUser.uid)
          .collection("revenue")
          .doc(id)
          .delete()
          .then(() => {
            resolve();
            // Document deleted successfully
          })
          .catch((error) => {

            console.error("Error getting documents: ", error);
          });



        // multiStoreCalc-TestMulti

      })
    },
    deactivateCrossVariant({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-DeCrossVariantCosts', body: {}
        }, { root: true }).then(x => {

        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    changeProductImportTotal({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid)
          .update({ importTotal: data }) // Use update() instead of set()
          .then(() => {
            commit("setimportTotal", data)
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    finalOnboardingImport({ commit, dispatch }, data) {
      console.log("-d-", data)
      commit("setfirstImportOpen", data)
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid)
          .update({ firstImportOpen: data }) // Use update() instead of set()
          .then(() => {

            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });



    },




    getLiveData({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GetLiveData', body: {}
        }, { root: true }).then(x => {

          console.log("live x", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getLiveDataLastHour({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GetLiveDataForCurrentHour', body: {}
        }, { root: true }).then(x => {

          console.log("live x", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getLiveDataMulti({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GetLiveDataMulti', body: data
        }, { root: true }).then(x => {

          console.log("live x", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getLiveDataMultiLastHour({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GetLiveDataMultiHourly', body: data
        }, { root: true }).then(x => {

          console.log("live x", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getAttributedMarketing({ commit, dispatch }, data) {
      console.log("ge mar")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GetAttributionData', body: data
        }, { root: true }).then(x => {

          console.log("live x", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    getImportedBundles({ commit, dispatch }, data) {
      console.log("ge mar")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-GetImportedBundles', body: data
        }, { root: true }).then(x => {

          console.log("imported bundles", x)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },


    setCustomBundleCost({ commit, dispatch }, data) {
      console.log("set custom cost")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-customBundleCost', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    setDigital({ commit, dispatch }, data) {
      console.log("set custom cost")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-customDigital', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },
    setTag({ commit, dispatch }, data) {
      console.log("set tag")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/shopify-addRefundTag', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    deleteTag({ commit, dispatch }, data) {
      console.log("delete digital")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/shopify-deleteRefundTag', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },


    GetTags({ commit }) {
      console.log("fetching product costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid).get()
          .then(x => {
            let data = x.data();
            let tags = data?.refundTags ?? {}
            resolve(tags);
          })
          .catch(e => { reject(e) })
      })
    },

    deleteCustomBundleCost({ commit, dispatch }, data) {
      console.log("set custom cost")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-deleteCustomBundleCost', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    deleteImportedBundle({ commit, dispatch }, data) {
      console.log("set custom cost")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-deleteImportedBundle', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    deleteDigital({ commit, dispatch }, data) {
      console.log("delete digital")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/userdata-deleteDigital', body: { data: data }
        }, { root: true }).then(x => {
          resolve("success")
        }).catch(error => {
          reject(error);
        });

        // multiStoreCalc-TestMulti

      })
    },

    setMultiStoreCurrency({ commit, dispatch }, data) {
      console.log("set multi store currency")
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/multiStoreCalc-SetMulitStoreCurrency', body: { data }
        }, { root: true }).then(x => {
          console.log("d", x)

          if (x.data == "success") {
            const nextMetaCurrency = data.currency ?? null
            commit("setmetaCurrency", nextMetaCurrency)
            return dispatch('SetCurrencySymbol', nextMetaCurrency).then(currencyObject => {
              commit("setStoreCurrencyObjectMeta", currencyObject)
              resolve(x.data);
            })
          } else {
            resolve(x.data);
          }
        }).catch(error => {
          reject(error);
        });

      })
    },

    firstCJImport({ commit, dispatch }, data) {
      console.log("cjImport")
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/cjDropshipping-firstImport', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    SendStoreRequest({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-sendStoreRequest', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    getStoreRequest({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-getStoreRequest', body: {
            data: data
          }
        }, { root: true }).then(x => {

          if (x.data) {
            commit('setstoreRequest', true)
          }

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    AcceptStoreRequest({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/multiStoreCalc-acceptStoreRequest', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    requestCredentials({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-GenerateCustomLogin', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    changeStoreName({ state, commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/multiStoreCalc-changeStoreName', body: {
            data: data
          }
        }, { root: true }).then(x => {


          const metaAccounts = state.metaAccounts;

          // Specify the specific URL you are looking for
          const specificUrl = firebase.auth().currentUser.uid

          // Find the object with the specific URL
          const foundObject = metaAccounts.find(account => account.url === specificUrl);

          // Check if the object was found
          if (foundObject) {
            // Change the value of the object
            foundObject.storeName = data.storeName // Replace with the property you want to change

            // Update the state
            // Assuming you have a mutation named 'updateMetaAccounts'

          }

          commit("setMetaAccounts", metaAccounts)




          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    removeAccount({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/multiStoreCalc-removeAccount', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },



    DenyStoreRequest({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-denyStoreRequest', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },



    SendHelpRequest({ commit, dispatch }, data) {

      console.log("data .", data)
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-HelpRequest', body: {
            data: data
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    // Cost per product
    GetMarketingCosts({ commit }) {
      console.log("fetching marketing costs from firebase...")
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("product-marketing").doc(firebase.auth().currentUser.uid).get()
          .then(x => {
            commit("setMarketingCost", x.data())
            resolve(x.data());
          })
          .catch(e => { reject(e) })
      })
    },
    // Everything about FixPayments
    async SetRecurringFixPayment({ commit }, fixedPayment) {
      const docRef = firebase.firestore().collection('fix-payments').doc(firebase.auth().currentUser.uid);

      // Get the current fix payments array
      const currentFixPaymentsDoc = await docRef.get();

      // If the array does not exist, create it
      let currentFixPayments = [];
      if (currentFixPaymentsDoc.exists && currentFixPaymentsDoc.data().recurringPayments) {
        currentFixPayments = currentFixPaymentsDoc.data().recurringPayments;
      }

      // Add the new fixedPayment to the array
      currentFixPayments.push(fixedPayment);

      // Save the updated array to Firestore
      return new Promise((resolve, reject) => {
        docRef.set({ recurringPayments: currentFixPayments })
          .then(_ => {
            commit("setFixPayments", currentFixPayments)
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    },


    async GetRecurringFixPayments({ commit }) {
      console.log("fetching fixpayments costs from firebase...");
      const docRef = firebase.firestore().collection("fix-payments").doc(firebase.auth().currentUser.uid);

      return new Promise((resolve, reject) => {
        docRef.get()
          .then(docSnapshot => {
            if (docSnapshot.exists) {
              const data = docSnapshot.data();
              if (data.recurringPayments) {
                commit("setFixPayments", data.recurringPayments)
                resolve(data.recurringPayments);
              } else {
                resolve([]);
              }
            } else {
              resolve([]);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    // Inside your store.js actions
    async DeleteRecurringFixPayment({ state, dispatch }, indexToDelete) {
      const updatedFixedPayments = state.fixPayments.filter((_, index) => index !== indexToDelete);

      return new Promise((resolve, reject) => {
        firebase.firestore().collection('fix-payments').doc(firebase.auth().currentUser.uid)
          .update({ recurringPayments: updatedFixedPayments }) // Use update() instead of set()
          .then(() => {
            dispatch('GetRecurringFixPayments');
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    async UpdateRecurringFixPayment({ state, dispatch }, data) {
      const newAmount = data.payment.amount;
      const endDate = data.payment.endDate;  // New amount value
      const indexToUpdate = data.index;       // Index to update

      // Create a copy of the fixPayments array and update the specific payment's amount
      const updatedFixedPayments = state.fixPayments.map((payment, index) => {
        if (index === indexToUpdate) {
          return {
            ...payment,
            amount: newAmount,
            endDate: endDate,
          };
        }
        return payment;
      });

      return new Promise((resolve, reject) => {
        firebase.firestore().collection('fix-payments').doc(firebase.auth().currentUser.uid)
          .update({ recurringPayments: updatedFixedPayments }) // Use update() instead of set()
          .then(() => {
            dispatch('GetRecurringFixPayments');
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    async SetTransaction({ dispatch, commit, state }, transaction) {

      return new Promise((resolve, reject) => {


        dispatch('api/apiPostWithToken', {
          path: '/operatingExpenses-SaveSingleTransaction', body: {
            data: transaction,
          }
        }, { root: true }).then(x => {

          if (x.data == "-") {
            resolve()
            return;
          }
          const currentTransaction = { ...x.data, id: x.data.id };
          commit("setTransactions", [...state.transactions, currentTransaction]);



          dispatch('api/apiPostWithToken', {
            path: '/multiStoreCalc-CheckRecalcMutliStoreOperating', body: {
              transaction: currentTransaction,
              action: "add",
              metaAccount: state.metaAccount

            }
          }, { root: true }).then(x => {

          }).catch(error => {
            reject(error);
          });

          resolve();

        }).catch(error => {
          reject(error);
        });
      })
    },
    async UpdateTransaction({ dispatch, commit, state }, transaction) {

      return new Promise((resolve, reject) => {


        dispatch('api/apiPostWithToken', {
          path: '/operatingExpenses-UpdateSingleTransaction', body: {
            data: transaction,
          }
        }, { root: true }).then(x => {
          var data = x.data
          const updatedTransactionIndex = state.transactions.findIndex(transaction => transaction.id === data.id);

          if (updatedTransactionIndex !== -1) {
            const updatedTransactions = [...state.transactions];
            updatedTransactions[updatedTransactionIndex] = data;
            commit("setTransactions", updatedTransactions);
          } else {
            const currentTransaction = { ...data, id: data.id };
            commit("setTransactions", [...state.transactions, currentTransaction]);
          }

          dispatch('api/apiPostWithToken', {
            path: '/multiStoreCalc-CheckRecalcMutliStoreOperating', body: {
              transaction: transaction,
              action: "update",
              metaAccount: state.metaAccount

            }
          }, { root: true }).then(x => {
            resolve("success");
          }).catch(error => {
            reject(error);
          });


        }).catch(error => {
          reject(error);
        });





      })
    },

    async GetTransaction({ commit, state }, { start, end }) {

      // The following complicated structure is somehow the only way to make sure diffrent timzones get handled correctly
      const formatDate = (date) => {
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
      };

      const startString = formatDate(start);
      const endString = formatDate(end);

      var timeZone = "America/New_York"
      if (state.timeZone == "") {
        timeZone = "America/New_York"
      } else {
        timeZone = state.timeZone;
      }

      const adjustedStartDate = moment.tz(startString, 'MM/DD/YYYY', timeZone).startOf('day').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');
      const adjustedEndDate = moment.tz(endString, 'MM/DD/YYYY', timeZone).endOf('day').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');

      const startAsDate = new Date(adjustedStartDate);
      const endAsDate = new Date(adjustedEndDate);


      const docRef = firebase
        .firestore()
        .collection("fix-payments")
        .doc(firebase.auth().currentUser.uid)
        .collection("transactions")
        .where("date", ">=", startAsDate)
        .where("date", "<=", endAsDate)
        .orderBy("date");

      return new Promise((resolve, reject) => {
        docRef
          .get()
          .then((querySnapshot) => {
            let transactions = [];
            querySnapshot.forEach((doc) => {
              transactions.push({ id: doc.id, ...doc.data() });
            });
            transactions.sort((a, b) => b.date.toDate() - a.date.toDate());
            commit("setTransactions", transactions);
            resolve();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
 async GetOrdersImportedCost({ commit, state }, { start, end }) {
  // Helper to format the input dates like before
  const formatDate = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const startString = formatDate(start);
  const endString = formatDate(end);

  let timeZone = state.timeZone || "America/New_York";

  // Use moment-timezone to normalize start/end to the shop’s timezone
  const startMoment = moment
    .tz(startString, "MM/DD/YYYY", timeZone)
    .startOf("day");
  const endMoment = moment.tz(endString, "MM/DD/YYYY", timeZone).endOf("day");

  // Build list of month keys between start and end: 2025|10, 2025|11, ...
  const months = [];
  let cursor = startMoment.clone().startOf("month");
  const lastMonth = endMoment.clone().startOf("month");

  while (cursor.isSameOrBefore(lastMonth, "month")) {
    months.push({
      year: cursor.year(),
      month: cursor.month() + 1, // 1–12
    });
    cursor.add(1, "month");
  }



  const db = firebase.firestore();

  const shopUrl = firebase.auth().currentUser.uid;

  const orders = [];

  for (const { year, month } of months) {
    // If you stored months without leading zero (2025|1), drop the padStart.
    const monthKey = `${year}|${month.toString().padStart(2, "0")}`;

    const monthSnap = await db
      .collection("order_imported_cost")
      .doc(shopUrl)
      .collection(monthKey)
      .get();

   
    monthSnap.forEach((doc) => {
      // Skip meta doc
      if (doc.id === "mergeData") return;

      const data = doc.data();
      console.log("data", data)
      if (!data || typeof data !== "object") return;

      // data looks like:
      // {
      //   "14": { "#3936": 0, "#3938": 3.5 },
      //   "19": { "#3937": 2.1 },
      //   ...
      // }
      Object.entries(data).forEach(([dayKey, orderMap]) => {
        const day = parseInt(dayKey, 10);
        if (Number.isNaN(day)) return;
        if (!orderMap || typeof orderMap !== "object") return;

        // Build a moment for this day in the shop's timezone
        const dateMoment = moment.tz(
          { year, month: month - 1, day },
          timeZone
        );

        // Filter by requested date range
        if (dateMoment.isBefore(startMoment) || dateMoment.isAfter(endMoment)) {
          return;
        }

        // orderMap: { "#3936": 0, "#3938": 3.5, ... }
        Object.entries(orderMap).forEach(([orderName, cost]) => {
          orders.push({
            order: orderName,
            cost: cost ?? 0,
            createDate: dateMoment.format("DD.MM.YYYY"), // 17.09.2025
          });
        });
      });
    });
  }

  // Optional: sort newest first by date, then by order name
  orders.sort((a, b) => {
    const aDate = moment(a.createDate, "DD.MM.YYYY").toDate();
    const bDate = moment(b.createDate, "DD.MM.YYYY").toDate();
    return bDate - aDate || a.order.localeCompare(b.order);
  });


  // Action returns the array as well
  return orders;
},

async GetInvoiceMeta({ state }, { start, end }) {
  // Helper to format the input dates like in GetOrdersImportedCost
  const formatDate = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const startString = formatDate(start);
  const endString = formatDate(end);

  const timeZone = state.timeZone || "America/New_York";

  // Normalize to start/end of day in shop timezone
  const startMoment = moment
    .tz(startString, "MM/DD/YYYY", timeZone)
    .startOf("day");
  const endMoment = moment
    .tz(endString, "MM/DD/YYYY", timeZone)
    .endOf("day");

  const startDate = startMoment.toDate();
  const endDate = endMoment.toDate();

  const db = firebase.firestore();
  const shopUrl = firebase.auth().currentUser.uid;

  // Base query: invoices/{shop}/uploads
  let query = db
    .collection("invoices")
    .doc(shopUrl)
    .collection("uploads");

  // Range by uploadDate (serverTimestamp saved in backend)
  query = query.where("uploadDate", ">=", startDate);
  query = query.where("uploadDate", "<=", endDate);

  // Order newest first
  query = query.orderBy("uploadDate", "desc");

  const snap = await query.get();

  const invoices = [];
  snap.forEach((doc) => {
    const data = doc.data() || {};
    invoices.push({
      id: doc.id,
      invoiceName: data.invoiceName || "",
      uploadDate: data.uploadDate || null, // Firestore Timestamp or null
    });
  });

  // Optional: safety sort on client if needed
  invoices.sort((a, b) => {
    const aDate = a.uploadDate?.toDate
      ? a.uploadDate.toDate()
      : a.uploadDate || 0;
    const bDate = b.uploadDate?.toDate
      ? b.uploadDate.toDate()
      : b.uploadDate || 0;
    return bDate - aDate;
  });

  return invoices;
},


    async SetDayliOperating({ dispatch, commit, state }) {
      const docRef = firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid)

      return new Promise((resolve, reject) => {
        docRef.set({ operatingCostDaily: true }, { merge: true })
          .then(doc => {
            commit("setOperatingCostDaily", true)

            dispatch('api/apiPostWithToken', {
              path: '/multiStoreCalc-RecalculateMultiOperating', body: {
                metaAccount: state.metaAccount
              }
            }, { root: true }).then(x => {
              resolve();
            }).catch(error => {
              console.log(error)
              resolve();
            });


          })
          .catch(e => {
            reject(e);
          });
      });
    },
    async deactivateDayliOperating({ dispatch, commit, state }) {
      const docRef = firebase.firestore().collection('userdata').doc(firebase.auth().currentUser.uid)

      return new Promise((resolve, reject) => {
        docRef.set({ operatingCostDaily: false }, { merge: true })
          .then(doc => {
            commit("setOperatingCostDaily", false)

            dispatch('api/apiPostWithToken', {
              path: '/multiStoreCalc-RecalculateMultiOperating', body: {
                metaAccount: state.metaAccount
              }
            }, { root: true }).then(x => {
              resolve();
            }).catch(error => {
              console.log(error)
              resolve();
            });

          })
          .catch(e => {
            reject(e);
          });
      });
    },


    async DeleteTransaction({ dispatch, commit, state }, transactionId) {
      const docRef = firebase.firestore().collection('fix-payments').doc(firebase.auth().currentUser.uid).collection('transactions').doc(transactionId);

      return new Promise((resolve, reject) => {

        const updatedTransactions = state.transactions.filter(transaction => transaction.id !== transactionId);
        commit("setTransactions", updatedTransactions);

        docRef.delete()
          .then(() => {
            dispatch('api/apiPostWithToken', {
              path: '/multiStoreCalc-CheckRecalcMutliStoreOperating', body: {
                transaction: { id: transactionId },
                action: "delete",
                metaAccount: state.metaAccount

              }
            }, { root: true }).then(x => {
              resolve();
            }).catch(error => {
              reject(error);
            });

          })
          .catch(e => {
            reject(e);
          });

      });
    }

  },

}
